import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Configurations/AuthContext";
import { useEffect, useState } from "react";
import { showMenu } from "./CompanyMenu";
export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, logout } = useAuth();
  const handleLogout = () => {
    logout();
    navigate("/");
  };
  useEffect(() => {
    if (loading || !user) return;
  }, [user, loading, location.pathname, navigate]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <h2 className="logo">{user?.brandName}</h2>
            </div>
          </div>
            <div className="d-flex align-items-right">
              <div className="dropdown ms-sm-3 header-item gap-4">
                {showMenu("dashboard") && (
                  <Link className="nav-link menu-link" to={"/dashboard"}>
                    <i className="ri-home-4-line text-info me-1"></i>
                    <span data-key="t-dashboard">Dashboard</span>
                  </Link>
                )}
                {showMenu("marketing") && (
                  <Link to={"/leads"} className="nav-link menu-link">
                    <i className="ri-message-3-line text-success me-1"></i>
                    <span data-key="t-hotels">Leads</span>
                  </Link>
                )}
                {showMenu("flights") && (
                  <Link className="nav-link menu-link" to={"/flight/search"}>
                    <i className="ri-flight-takeoff-line text-success me-1"></i>
                    <span data-key="t-flights">Flights</span>
                  </Link>
                )}
                {showMenu("hotels") && (
                  <Link to={"/hotel/search"} className="nav-link menu-link">
                    <i className="ri-building-line text-success me-1"></i>
                    <span data-key="t-hotels">Hotels</span>
                  </Link>
                )}
                {showMenu("packages") && (
                  <Link to={"/package"} className="nav-link menu-link">
                    <i className="ri-luggage-deposit-line text-success me-1"></i>
                    <span data-key="t-Packages">Packages</span>
                  </Link>
                )}
                {showMenu("sightseeing") && (
                  <Link
                    className="nav-link menu-link"
                    to={"/sightseeing/search"}
                  >
                    <i className="mdi mdi-map-marker-outline text-success me-1"></i>
                    <span data-key="t-Packages">SightSeeing</span>
                  </Link>
                )}
                {showMenu("Visas") && (
                  <Link className="nav-link menu-link" to={"/visarequests"}>
                    <i className="ri-passport-line  text-success me-1"></i>
                    <span data-key="t-visas">Visas</span>
                  </Link>
                )}
                {showMenu("umrah") && (
                  <Link className="nav-link menu-link" to={"/umrah"}>
                    <i className="mdi mdi-star-crescent text-success me-1"></i>
                    <span data-key="t-Packages">Umrah</span>
                  </Link>
                )}
                {showMenu("hajj") && (
                  <Link className="nav-link menu-link" to={"/hajj"}>
                    <i className="mdi mdi-mosque text-success me-1"></i>
                    <span data-key="t-hajj">Hajj</span>
                  </Link>
                )}
              </div>
            </div>
          <div className="d-flex align-items-center">
            <div className="dropdown ms-sm-3 header-item topbar-user">
              <button
                type="button"
                className="btn shadow-none"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="d-flex align-items-center">
                  <span className="text-start ms-xl-2">
                    Welcome,
                    <span className="d-none text-bold d-xl-inline-block ms-1 fw-medium user-name-text">
                      {user?.brandName}
                    </span>
                  </span>
                </span>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <h6 className="dropdown-header">Welcome!</h6>
                <Link className="dropdown-item" to={"/companyprofile"}>
                  <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Profile</span>
                </Link>
                <Link className="dropdown-item" to={"/gstreport"}>
                  <i className="ri-building-line text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Reports</span>
                </Link>
                <Link className="dropdown-item" to={"/suppliers"}>
                  <i className="ri-folder-settings-line text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Settings</span>
                </Link>
                <Link className="dropdown-item" to={"/agents"}>
                  <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Agents</span>
                </Link>
                <button className="dropdown-item" onClick={handleLogout}>
                  <i className="mdi mdi-logout text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
